import React, { FunctionComponent } from 'react';
import { FAQItemI } from '../../types';
import { Button } from '../Button/ButtonV2';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-regular-svg-icons';
import { Row } from '../Row';

interface PropsFaqI {
  faq: FAQItemI;
  selectPositionFaqEdit: (position: number) => void;
  handlerDelete: (id: number) => void;
  position: number;
}

export const Faq: FunctionComponent<PropsFaqI> = ({
  faq,
  selectPositionFaqEdit,
  handlerDelete,
  position
}) => {
  return (
    <Row align="center" justify="space-between">
      <p className="text-base truncate w-3/5">{faq.name}</p>
      <Row align="center" justify="flex-end" gap={8} className="w-2/5">
        <Button size="icon" rounded="full" variant="muted" onClick={() => selectPositionFaqEdit(position)}>
          <FontAwesomeIcon icon={faEdit} width="15px" height="15px" color="#0072FB" />
        </Button>
        <Button size="icon" rounded="full" variant="muted" onClick={() => handlerDelete(position)}>
          <FontAwesomeIcon icon={faTrashAlt} width="15px" height="15px" color="#FF4D4F" />
        </Button>
      </Row>
    </Row>
  );
};
